export enum Actions {
  SetIsDarkMode = 'auth/SetIsDarkMode',
}

export const setIsDarkMode = (isDark: boolean) => ({
  type: Actions.SetIsDarkMode,
  isDark,
});
